import Router from './shared/Router';
import ReactModal from 'react-modal';
ReactModal.setAppElement('#root');

const App = () => {

  return (

    <Router />

  )

}

export default App;